export const CyStubAuth = {
  LoginButtonPrefix: "LoginButton",
} as const;
